import { render, staticRenderFns } from "./WorkflowSection.vue?vue&type=template&id=d3c12db4&scoped=true"
import script from "./WorkflowSection.vue?vue&type=script&lang=js"
export * from "./WorkflowSection.vue?vue&type=script&lang=js"
import style0 from "./WorkflowSection.vue?vue&type=style&index=0&id=d3c12db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c12db4",
  null
  
)

export default component.exports